let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gGi2t")).then(() => parcelRequire('h7wRb'));